module.exports = __webpack_public_path__ + "static/media/SF-7-A.d08e209a.mp3";